import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import { Tooltip } from "antd";
import XtLoading from "@/components/Xt/Loading";
import NoData from "components/App/div/noData";
import CurrencySelect from "components/Pages/Finance/_cmpt/CurrencySelect";
// import DropProducts from "@/components/Pages/Finance/Drop/Products";
import DropDuration from "@/components/Pages/Finance/Drop/Duration";
import DropSelect from "@/components/Pages/Finance/Drop/Select";
import TableRow from "./TableRow";
import cx from "classnames";
import styles from "./index.module.less";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { get_product } from "api/v4/finance";
import XtSvg from "@/components/Xt/Svg";
import useSortByApy from "@/components/Pages/Finance/_hook/useSortByApy";

export default observer(() => {
  const t = useTranslation();
  const { app, finance } = useStore();

  const limit = 8;
  const fromPage = useRef(1);

  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState([]);

  const [filterDuration, setFilterDuration] = useState("ALL");
  const [filterSelect, setFilterSelect] = useState([]);
  const [currency, setCurrency] = useState();

  const isAvailable = useMemo(() => filterSelect.includes("displayAvailableOnly"), [filterSelect]);
  const isMatchMyAssets = useMemo(() => filterSelect.includes("matchMyAssets"), [filterSelect]);
  const isSortByApy = useMemo(() => filterSelect.includes("sortByApy"), [filterSelect]);

  const [hasMore, setHasMore] = useState(false);

  const apiReq = useCallback(
    (isMore) => {
      if (loading) return;
      setLoading(true);
      if (!isMore) fromPage.current = 1;

      get_product({
        params: {
          categories: "SAVING",
          available: filterSelect.includes("displayAvailableOnly") ? true : undefined,
          matchMyAssets: filterSelect.includes("matchMyAssets") ? true : undefined,
          // sortByApy: filterSelect.includes("sortByApy") ? true : undefined,
          duration: filterDuration,
          currency,
          limit: -1,
          fromPage: fromPage.current + (isMore ? 1 : 0),
        },
        errorPop: true,
      })
        .then((result) => {
          setResData(isMore ? [...resData, ...result.items] : result.items || []);
          setHasMore(result.hasNext);
          isMore && (fromPage.current = fromPage.current + 1);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [resData, loading, isAvailable, isMatchMyAssets, filterDuration, currency]
  );

  useEffect(() => {
    apiReq();
  }, [isAvailable, isMatchMyAssets, filterDuration, currency]);

  const onViewMore = useCallback(() => {
    apiReq(true);
  }, [apiReq]);

  const [isExpand, setIsExpand] = useState(false);

  const resDataSort = useSortByApy(resData, isSortByApy);
  const resDataSortConvert = useMemo(() => {
    const list = [];
    resDataSort.map((obj) => {
      const { apyMax, groupTag } = obj;
      obj.productCollections.map((product, index) => {
        !product.apyMax && (product.apyMax = apyMax);
        product.groupTag = groupTag;
        product.key = groupTag + index;
        list.push(product);
      });
    });

    isSortByApy && list.sort((a, b) => b.apyMax - a.apyMax);

    console.log("list ===", list);
    return list;
  }, [resDataSort, isSortByApy]);
  const items = useMemo(() => resDataSortConvert.slice(0, isExpand ? undefined : limit), [resDataSortConvert, isExpand]);
  console.log("items ==", items);

  const isMoreBtn = useMemo(() => resDataSortConvert.length > limit, [resDataSortConvert]);
  const onMoreBtnClick = useCallback(() => setIsExpand(!isExpand), [isExpand]);

  const [timestamp, setTimestamp] = useState("");
  useEffect(() => {
    setTimestamp(Date.now());
  }, [resDataSortConvert]);

  return (
    <div className={styles.main}>
      <h2 className={stylesProducts.title}>{t("finance.allProducts")}</h2>
      <div className={stylesProducts.content}>
        <div className={stylesProducts.filterCon}>
          <div>
            <DropDuration data={filterDuration} callback={setFilterDuration} />
            <DropSelect data={filterSelect} callback={setFilterSelect} />
          </div>
          <div>
            <CurrencySelect className={stylesProducts.search} value={currency} onChange={setCurrency} />
          </div>
        </div>

        <div className={stylesProducts.bodyCon}>
          {!app.isH5 && (
            <div className={cx(stylesProducts.tableNav, styles.tableRowLayout)}>
              <div>{t("finance.coin")}</div>
              <div>{t("finance.apy")}</div>
              <div>{t("finance.durationDays")}</div>
              <div>
                <Tooltip color={"rgba(0, 0, 0, 0.6)"} title={<span style={{ color: "#fff" }}>{t("finance.autoTip")}</span>}>
                  <span className={stylesProducts.tableNavTip}>{t("finance.autoSubscribe")}</span>
                </Tooltip>
              </div>
              <div>{t("console.operate")}</div>
            </div>
          )}

          <div className={stylesProducts.tableCon}>
            {!items.length ? (
              <NoData className={stylesProducts.noData} />
            ) : (
              <>
                {items.map((data) => {
                  return !!data.key && <TableRow key={data.key + "-" + timestamp} data={data} rowCls={styles.tableRowLayout} />;
                })}

                {isMoreBtn && (
                  <div className={stylesProducts.more}>
                    <button className={cx("btnTxt")} onClick={onMoreBtnClick}>
                      <span>{isExpand ? t("finance.collapse") : t("cmpt.viewmore")}</span>
                      <XtSvg icon={"doubleArrow"} style={{ marginLeft: "5px", transform: isExpand ? "rotateZ(-90deg)" : "rotateZ(90deg)" }} />
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {loading && <XtLoading />}
      </div>
    </div>
  );
});
